module.exports = __webpack_public_path__ + "img/logo.ceed31b9.png";